import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class GoogleEncryptionService {
	private basePath = `${environment.api.baseUrl}/encryption`;

	constructor(private httpClient: HttpClient) {}

	encrypt(plaintext?: string): Observable<string> {
		if (!plaintext) {
			return of('');
		}

		const encoded = encodeURIComponent(plaintext);
		const url = `${this.basePath}/encrypt?plaintext=${encoded}`;
		return this.httpClient.get<string>(url, { responseType: 'text' as 'json' });
	}

	decrypt(ciphertext?: string): Observable<string> {
		if (!ciphertext) {
			return of('');
		}

		const encoded = encodeURIComponent(ciphertext);
		const url = `${this.basePath}/decrypt?ciphertext=${encoded}`;
		return this.httpClient
			.get<string>(url, { responseType: 'text' as 'json' })
			.pipe(
				catchError((err) => {
					LogRocket.captureException(err);
					return of(ciphertext);
				}),
			);
	}

	validate(value: string, ciphertext: string): Observable<boolean> {
		const encodedvaluetext = encodeURIComponent(value);
		const encodedCiphertext = encodeURIComponent(ciphertext);

		const url = `${this.basePath}/validate?value=${encodedvaluetext}&ciphertext=${encodedCiphertext}`;
		return this.httpClient.get<boolean>(url);
	}
}
